import { AsphaltMixDesigns } from '../../../cimsPage/instances/materials'
import { Simple } from '../../common'

const object = 'Asphalt Mix Design'
const page = AsphaltMixDesigns

export const CreateAsphaltMixDesign = Simple({
  id: 'fb231484-0821-466f-840d-97a1d0bee8d6',
  action: 'Create',
  object,
  page,
})

export const EditAsphaltMixDesign = Simple({
  id: 'dd5ebc5d-1b7b-44a3-ab76-49c0433d05ef',
  action: 'Edit',
  object,
  page,
})

export const ViewAsphaltMixDesign = Simple({
  id: '25b8445e-c62d-47d5-8fa3-1c5544fd0d24',
  action: 'View',
  object,
  page,
})

export type AsphaltMixDesignPermissionItem =
  | typeof CreateAsphaltMixDesign
  | typeof EditAsphaltMixDesign
  | typeof ViewAsphaltMixDesign
